var exports = {
  "Y": "CtaButtons__uOqnE0",
  "$": "Button__HnJLcF",
};

module.exports = exports;
